angular.module('shared').factory('ActivityService', function() {
  return {
    getIconClass: function(event) {
      var ref, ref1, ref10, ref11, ref12, ref13, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
      switch (false) {
        case (ref = event.type) !== 'attendance_log_entry' && ref !== 'contact_attendance_log_entry' && ref !== 'roll_call_booking_log_entry':
          return 'activity-attendance';
        case (ref1 = event.type) !== 'booking_log_entry' && ref1 !== 'waitlist_log_entry' && ref1 !== 'recurring_booking_log_entry':
          return 'activity-booking';
        case (ref2 = event.type) !== 'late_booking_cancellation_log_entry' && ref2 !== 'booking_cancellation_log_entry':
          return 'activity-booking activity--failed';
        case event.type !== 'kiosk_checkin_alert_log_entry':
          return 'activity-warning';
        case event.type !== 'contact_flag_log_entry':
          return 'activity-flag';
        case event.type !== 'contact_relationship_log_entry':
          return 'activity-family';
        case event.type !== 'credit_voucher_log_entry':
          return 'activity-credit-voucher';
        case (ref3 = event.type) !== 'signed_waiver_log_entry' && ref3 !== 'signed_waiver_merge_log_entry' && ref3 !== 'signed_waiver_review_log_entry' && ref3 !== 'signed_waiver_consent_request_log_entry':
          return 'activity-waiver';
        case event.type !== 'contact_workout_log_entry':
          return 'activity-workout';
        case (ref4 = event.type) !== 'grading_log_entry' && ref4 !== 'grading_event_log_entry' && ref4 !== 'roll_call_promotion_log_entry' && ref4 !== 'member_style_log_entry':
          return 'activity-style';
        case event.type !== 'member_style_delete_log_entry':
          return 'activity-style activity--failed';
        case event.type !== 'sequence_log_entry':
          return 'activity-sequence';
        case event.type !== 'task_log_entry':
          return 'activity-task';
        case event.type !== 'sale_log_entry':
          return 'activity-sale';
        case event.type !== 'contact_comms_recipient_log_entry':
          return 'activity-comms-recipient';
        case event.type !== 'data_series_log_entry':
          return 'activity-data-series';
        case (ref5 = event.type) !== 'contact_brivo_detail_log_entry' && ref5 !== 'contact_brivo_credential_log_entry' && ref5 !== 'contact_brivo_door_access_log_entry' && ref5 !== 'contact_innertelligence_credential_log_entry' && ref5 !== 'doorguard_action_log_entry':
          return 'activity-access-control';
        case (ref6 = event.type) !== 'report_log_entry' && ref6 !== 'static_report_exclusion_log_entry':
          return 'activity-report';
        case event.type !== 'member_mobile_app_detail_log_entry':
          return 'activity-mobile-app';
        case (ref7 = event.type) !== 'email_log_entry' && ref7 !== 'email_event_log_entry' && ref7 !== 'contact_email_verification_log_entry':
          return 'activity-email';
        case event.type !== 'contact_email_unsubscribe_log_entry':
          return 'activity-email activity--failed';
        case (ref8 = event.type) !== 'member_log_entry' && ref8 !== 'prospect_log_entry' && ref8 !== 'contact_log_entry' && ref8 !== 'contact_nac_conversion_log_entry' && ref8 !== 'contact_suspension_log_entry' && ref8 !== 'contact_conversion_log_entry' && ref8 !== 'prospect_signup_log_entry' && ref8 !== 'privacy_policy_acceptance_log_entry':
          return 'activity-user';
        case (ref9 = event.type) !== 'invoice_log_entry' && ref9 !== 'failure_fee_log_entry' && ref9 !== 'payment_plan_log_entry':
          return 'activity-payment';
        case (ref10 = event.type) !== 'payment_method_log_entry' && ref10 !== 'stripe_payment_method_auth_log_entry' && ref10 !== 'wallet_sharing_log_entry' && ref10 !== 'gocardless_mandate_log_entry':
          return 'activity-wallet';
        case (ref11 = event.type) !== 'membership_log_entry' && ref11 !== 'membership_expired_log_entry' && ref11 !== 'membership_replacement_log_entry' && ref11 !== 'membership_interruption_request_log_entry':
          return 'activity-membership';
        case (ref12 = event.type) !== 'membership_deletion_log_entry' && ref12 !== 'membership_cancellation_log_entry':
          return 'activity-membership activity--failed';
        case !(event.type === 'conversation_log_entry' && event.data.channel === 'email'):
          return 'activity-email';
        case !(event.type === 'conversation_log_entry' && event.data.channel === 'sms'):
          return 'activity-sms';
        case !(event.type === 'conversation_log_entry' && event.data.channel === 'push_notification'):
          return 'activity-push-notification';
        case event.type !== 'push_notification_failure_log_entry':
          return 'activity-push-notification activity--failed';
        case (ref13 = event.type) !== 'sms_failure_log_entry' && ref13 !== 'contact_sms_unsubscribe_log_entry':
          return 'activity-sms activity--failed';
        case event.type !== 'sms_reply_log_entry':
          return 'activity-sms sms-reply';
        case event.type !== 'note_log_entry':
          return 'activity-note';
        default:
          return 'activity-default';
      }
    },
    payloadTypeClass: function(type) {
      switch (type) {
        case 'EmailSequencePayload':
          return 'activity-email';
        case 'EmailUserSequencePayload':
          return 'activity-email';
        case 'SmsSequencePayload':
          return 'activity-sms';
        case 'PushNotificationSequencePayload':
          return 'activity-push-notification';
        case 'NewMembershipSequencePayload':
          return 'activity-membership';
        case 'ContactWorkoutSequencePayload':
          return 'activity-workout';
        case 'NewMemberStyleSequencePayload':
          return 'activity-style';
        case 'AddCreditVoucherSequencePayload':
          return 'activity-credit-voucher';
        case 'TaskSequencePayload':
          return 'activity-task';
        case 'MemberPortalSequencePayload':
          return 'activity-user';
        case 'MobileAppSequencePayload':
          return 'activity-mobile-app';
        case 'ProspectStatusChangeSequencePayload':
          return 'activity-prospect-status-change';
        case 'SendWaiverSequencePayload':
          return 'activity-waiver';
        case 'AddMakeupClassSequencePayload':
          return 'activity-make-up-class';
        case 'ConvertToNacSequencePayload':
          return 'activity-user';
        case 'AddContactFlagSequencePayload':
          return 'activity-flag';
        case 'FormFieldUpdateSequencePayload':
          return 'activity-user';
        case 'AddNoteSequencePayload':
          return 'activity-note';
        case 'AddBrivoCredentialSequencePayload':
          return 'activity-access-control';
      }
    }
  };
});
